import { Box, Button, Grid, Dialog, Paper, DialogActions, DialogContentText, DialogContent, DialogTitle, Snackbar } from "@material-ui/core";
import { format } from "date-fns";
import _ from "lodash";
import axios from "axios";
import { useOktaAuth } from "@okta/okta-react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getRequests } from "../../actions";
import MuiAlert from "@material-ui/lab/Alert";

import BrandIcons from "../Common/BrandIcons";
import RoleIcons from "../Common/RoleIcons";
import RequestsBreadcrumb from "./RequestsBreadcrumb";

const Alert = (props) => {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
};

const ApprovedRequest = ({ item }) => {
    let approvalData;
    if (item.approvalData) {
        approvalData = JSON.parse(item.approvalData);
    }
    const dispatch = useDispatch();
    const { oktaAuth, authState } = useOktaAuth();
    const [modalOpen, setModalOpen] = useState(false);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastContent, setToastContent] = useState("");
    const toggleModal = () => setModalOpen(!modalOpen);
    const resetStatus = () => {
        setModalOpen(true);
    };
    const confirmStatusReset = async () => {
        console.log("resetting status to pending");
        setModalOpen(!modalOpen);
        const token = oktaAuth.getAccessToken();
        axios
            .post(
                `${process.env.REACT_APP_APIHOST}/api/resetrequeststatus`,
                {
                    item,
                },
                {
                    headers: {
                        authorization: `Bearer ${token}`,
                    },
                }
            )
            .then((res) => {
                console.log(res.data);
                if (res.data.success) {
                    setToastContent(
                        <Alert onClose={handleToastClose} severity='success'>
                            {res.data.message}
                        </Alert>
                    );
                } else {
                    setToastContent(
                        <Alert onClose={handleToastClose} severity='error'>
                            {res.data.message}
                        </Alert>
                    );
                }
                setToastOpen(true);
            })
            .catch(function (error) {});
    };

    const handleToastClose = (event, reason) => {
        const token = oktaAuth.getAccessToken();
        if (reason === "clickaway") {
            dispatch(getRequests(token));
            return;
        }
        setToastOpen(false);
        dispatch(getRequests(token));
    };
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Paper>
                        <Box p={1}>
                            <Box p={1}>
                                <RequestsBreadcrumb item={item} />
                            </Box>
                        </Box>
                        <Box p={1}>
                            <h4>This request was approved on {format(new Date(item.approval_date), "EEEE, MMMM do yyyy, h:mm:ss a")}</h4>
                            <div>
                                <strong>Request Approval Details:</strong>
                            </div>
                            <hr />
                            {approvalData ? (
                                <>
                                    <div>
                                        <strong>Request ID: </strong>
                                        {approvalData.id}
                                    </div>
                                    <div>
                                        <strong>Requested On: </strong>
                                        {format(new Date(item.request_date), "EEEE, MMMM do yyyy, h:mm:ss a")}
                                    </div>
                                    <div>
                                        <strong>Username: </strong>
                                        {approvalData.username}
                                    </div>
                                    <div>
                                        <strong>Name: </strong>
                                        {approvalData.firstName ? (
                                            <>
                                                {approvalData.firstName} {approvalData.lastName}
                                            </>
                                        ) : (
                                            <>
                                                {item.firstName} {item.lastName}
                                            </>
                                        )}
                                    </div>
                                    <div>
                                        <strong>Email: </strong>
                                        {approvalData.email}
                                    </div>
                                    <div>
                                        <strong>Role: </strong>
                                        {/* <IconsList location={false} type='roles' slugs={[approvalData.userRole]} /> */}
                                        <RoleIcons slug={approvalData.userRole} />
                                    </div>
                                    <div>
                                        <strong>Location: </strong>
                                        {item.location ? item.location : approvalData.locale}
                                    </div>
                                    <div>
                                        <strong>Brands: </strong>
                                        {/* <IconsList location={item.location} type='brands' slugs={brandsArry} /> */}
                                        {_.map(_.compact(item.assocBrands.split(";")), (brand, i) => {
                                            return <BrandIcons key={i} slug={brand} location={item.location} />;
                                        })}
                                    </div>
                                    <div>
                                        <strong>Approved By: </strong>
                                        {approvalData.approvingAdmin.profile.displayName} - {approvalData.approvingAdmin.profile.login}
                                    </div>
                                </>
                            ) : (
                                <>Missing Approval Data</>
                            )}
                            <Box my={3}>
                                <Button variant='contained' color='primary' onClick={() => resetStatus()}>
                                    Reset Request Status
                                </Button>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
            <Dialog open={modalOpen} onClose={toggleModal} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
                <DialogTitle id='alert-dialog-title'>Reset Request Status?</DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>Please confirm that you want to reset the status for this Request.</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={toggleModal} color='default'>
                        Cancel
                    </Button>
                    <Button onClick={confirmStatusReset} color='primary' autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={toastOpen} autoHideDuration={6000} onClose={handleToastClose}>
                <>{toastContent}</>
            </Snackbar>
        </>
    );
};

export default ApprovedRequest;
